import PropTypes from "prop-types"

export default PropTypes.shape({
  PaginationAnnouncer: PropTypes.elementType.isRequired,
  currentPage: PropTypes.number.isRequired,
  numberOfPages: PropTypes.number.isRequired,
  visibleIndices: PropTypes.arrayOf(PropTypes.number).isRequired,
  onChange: PropTypes.func.isRequired,
})
